import { Link, useParams, useNavigate } from 'react-router-dom';
import { Container } from '../layout/AppLayout.js'
import { useEffect, useContext } from 'react';
import { isAllowed } from '../shared/FeatureChecker.js';
import { useQuery } from 'react-query';
import Spinner from '../shared/Spinner.js';
import Header from "../shared/Header.js"
import { CurrentUserContext } from '../../App.js';
import { formatDate } from '../../utils.js';
import translate from './translate_event.js';
import translateLogin from './translate_event_login.js';

import useFeatureChecker, { AllowedFeature, DeniedFeature } from '../shared/FeatureChecker.js';

import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';

function DetailsCard({ log }) {
  const CheckFeatures = useFeatureChecker()
  if (log == null) { return null }
  return (
    <div>
      <div className="form-group">
        <label className="form-label font-weight-bold">Fecha de creación del evento</label>
        <p>{formatDate(log.time, "dd/MM/yyyy HH:mm:ss")}</p>
      </div>

      <div className="form-group">
        <label className="form-label font-weight-bold">Nombre</label>
        <p>{log.octoberus_name ? log.octoberus_name : "--"}</p>
      </div>

      <div className="form-group">
        <label className="form-label font-weight-bold">Evento</label>
        <p>{log.event_name ? translate(log.event_name) : "--"}</p>
      </div>

      <div className="form-group">
        <label className="form-label font-weight-bold">Source</label>
        <p>{log.source_ip ? log.source_ip : "--"}</p>
      </div>

      <div className="form-group">
        <label className="form-label font-weight-bold">Usuario</label>
        <p>
          {
            log.platform === "GCP" ?
              (
                <CheckFeatures feature='DETAIL_USER'>
                  <AllowedFeature>
                    <Link className="py-3" to={"/members/" + log.found_user}>
                      <span>
                        {log.user_id}
                      </span>
                    </Link>
                  </AllowedFeature>
                  <DeniedFeature>
                    <span>
                      {log.user_id}
                    </span>
                  </DeniedFeature>
                </CheckFeatures>
              ) :
              (
                <span> {log.user_name}<br />(
                  {
                    log.found_user ? (
                      <CheckFeatures feature='DETAIL_USER'>
                        <AllowedFeature>
                          <Link className="py-3" to={"/members/" + log.found_user}>
                            <span>
                              ({log.user_id})
                            </span>
                          </Link>
                        </AllowedFeature>
                        <DeniedFeature>
                          <span>
                            ({log.user_id})
                          </span>
                        </DeniedFeature>
                      </CheckFeatures>
                    ) : <span>({log.user_id})</span>
                  }
                  )</span>)
          }
        </p>
      </div>
      <div className="form-group">
        <label className="form-label font-weight-bold">Plataforma</label>
        <p>{log.platform ? log.platform : "--"}</p>
      </div>
    </div>
  )
}
function EventNameGCP(event) {
  if (event == null) { return null }
  return (
    <div>
      {
        event.extra_data && event.extra_data.role && event.extra_data.role.name ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Nombre del rol</label>
            <p>{event.extra_data.role.name}</p>
          </div>
        ) : null
      }

      {
        event.extra_data && event.extra_data.role && event.extra_data.role.member ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Miembro</label>
            <p>{event.extra_data.role.member}</p>
          </div>
        ) : null
      }
    </div>
  )
}

function EventNameAWS(event) {
  if (event == null) { return null }
  return (
    <div>
      {
        event.extra_data && event.extra_data.shell && event.extra_data.shell.environmentId ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Id entorno</label>
            <p>{event.extra_data.shell.environmentId}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.shell && event.extra_data.shell.session.type ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">tipo de consola</label>
            <p>{event.extra_data.shell.session.type}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.shell && event.extra_data.shell.session.id ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">id de la consola</label>
            <p>{event.extra_data.shell.session.id}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.group && event.extra_data.group.name ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Nombre del grupo</label>
            <p>{event.extra_data.group.name}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.group && event.extra_data.group.id ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Id del grupo</label>
            <p>{event.extra_data.group.id}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.group && event.extra_data.group.arn ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Arn del grupo</label>
            <p>{event.extra_data.group.arn}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.group && event.extra_data.group.newName ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Nuevo nombre del grupo</label>
            <p>{event.extra_data.group.newName}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.group && event.extra_data.group.newName ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Nuevo nombre del grupo</label>
            <p>{event.extra_data.group.newName}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.user && event.extra_data.user.name ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Nombre del usuario</label>
            <p>{event.extra_data.user.name}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.user && event.extra_data.user.id ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Id del usuario</label>
            <p>{event.extra_data.user.id}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.user && event.extra_data.user.consoleLogin ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Login</label>
            <p>{translateLogin(event.extra_data.user.consoleLogin)}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.user && event.extra_data.user.accessKey && event.extra_data.user.accessKey.id ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Id de la llave de acceso</label>
            <p>{event.extra_data.user.accessKey.id}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.user && event.extra_data.user.accessKey && event.extra_data.user.accessKey.status ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Estado de la llave de acceso</label>
            <p>{event.extra_data.user.accessKey.status}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.role && event.extra_data.role.id ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Id del rol</label>
            <p>{event.extra_data.role.id}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.role && event.extra_data.role.name ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Nombre del rol</label>
            <p>{event.extra_data.role.name}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.role && event.extra_data.role.arn ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Arn del rol</label>
            <p>{event.extra_data.role.arn}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.policy && event.extra_data.policy.name ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Politica</label>
            <p>{event.extra_data.policy.name}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.policy && event.extra_data.policy.arn ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Arn de la Politica</label>
            <p>{event.extra_data.policy.arn}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.policy && event.extra_data.policy.id ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Id de la Politica</label>
            <p>{event.extra_data.policy.id}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.bucket && event.extra_data.bucket.name ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Bucket</label>
            <p>{event.extra_data.bucket.name}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.bucket && event.extra_data.bucket.host ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Host del bucket</label>
            <p>{event.extra_data.bucket.host}</p>
          </div>
        ) : null
      }
      <hr />
      {
        event.extra_data && event.extra_data.error && event.extra_data.error.code ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Código de error</label>
            <p>{event.extra_data.error.code}</p>
          </div>
        ) : null
      }
      {
        event.extra_data && event.extra_data.error && event.extra_data.error.messagee ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Error</label>
            <p>{event.extra_data.error.messagee}</p>
          </div>
        ) : null
      }

      {
        event.extra_data && event.extra_data.MFA && event.extra_data.MFA.virtualMFADeviceName ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Nombre del Autenticación multifactor</label>
            <p>{event.extra_data.MFA.virtualMFADeviceName}</p>
          </div>
        ) : null
      }

      {
        event.extra_data && event.extra_data.MFA && event.extra_data.MFA.serialMumber ? (
          <div className="form-group">
            <label className="form-label font-weight-bold">Arn del Autenticación multifactor</label>
            <p>{event.extra_data.MFA.serialMumber}</p>
          </div>
        ) : null
      }

    </div>
  )
}

function DetailsAWSCard({ log }) {
  if (log == null) { return null }
  return (
    <div>
      <div className="form-group">
        <label className="form-label font-weight-bold">Región de aws</label>
        <p>{log.extra_data.awsRegion ? log.extra_data.awsRegion : "--"}</p>
      </div>
      <div className="form-group">
        <label className="form-label font-weight-bold">ID de la cuenta</label>
        <p>{log.extra_data.userIdentity.accountId ? log.extra_data.userIdentity.accountId : "--"}</p>
      </div>
      <div className="form-group">
        <label className="form-label font-weight-bold">ID del evento</label>
        <p>{log.extra_data.eventID ? log.extra_data.eventID : "--"}</p>
      </div>



      <div className="form-group">
        <label className="form-label font-weight-bold">Usuario</label>
        <p>{log.extra_data.userIdentity.name ? log.extra_data.userIdentity.name : "--"}</p>
      </div>

      <div className="form-group">
        <label className="form-label font-weight-bold">Tipo de Usuario</label>
        <p>{log.extra_data.userIdentity.type ? log.extra_data.userIdentity.type : "--"}</p>
      </div>

      <div className="form-group">
        <label className="form-label font-weight-bold">ID de la llave</label>
        <p>{log.extra_data.userIdentity.accessKeyId ? log.extra_data.userIdentity.accessKeyId : "--"}</p>
      </div>

    </div>
  )
}

function DetailsGCPCard({ log }) {
  if (log == null) { return null }
  return (
    <div>
      <div className="form-group">
        <label className="form-label font-weight-bold">Región de GCP</label>
        <p>{log.extra_data.gcpRegion ? log.extra_data.gcpRegion : "--"}</p>
      </div>
      <div className="form-group">
        <label className="form-label font-weight-bold">ID de la proyecto</label>
        <p>{log.extra_data.event && log.extra_data.event.projectId ? log.extra_data.event.projectId : "--"}</p>
      </div>
      <div className="form-group">
        <label className="form-label font-weight-bold">ID del evento</label>
        <p>{log.extra_data.insertId ? log.extra_data.insertId : "--"}</p>
      </div>
      <div className="form-group">
        <label className="form-label font-weight-bold">Usuario</label>
        <p>{log.user_name ? log.user_name : "--"}</p>
      </div>
      <div className="form-group">
        <label className="form-label font-weight-bold">Agente de la solicitud</label>
        <p>{log.extra_data.source && log.extra_data.source.agent ? log.extra_data.source.agent : "--"}</p>
      </div>
      <div className="form-group">
        <label className="form-label font-weight-bold">Ip de la solicitud</label>
        <p>{log.extra_data.source && log.extra_data.source.ip ? log.extra_data.source.ip : "--"}</p>
      </div>

    </div>
  )
}

export default function DigitalsDetailsPage() {
  const params = useParams()
  const currentUser = useContext(CurrentUserContext)
  const navigate = useNavigate()
  const query = useQuery(`logsdigitals/${params.LogId}`)

  useEffect(() => {
    if (currentUser) {
      const allowed = isAllowed({ user: currentUser, feature: "DETAIL_LOGS" })
      if (!allowed) {
        navigate('/error?error=403')
      }
    }

  }, [currentUser])

  return (
    <Container>
      <div className="row">
        <Header title="Detalle de logs digital" items={[
          { label: `Listado logs digital`, to: "/digitals" },
          { label: `Detalle del logs digital` },
        ]}>
        </Header>
      </div>
      <Row className="mb-2 pb-4">
        <div className="col-12 mb-2 col-lg-6">
          <Card className="shadow-sm mb-3">
            <Card.Header className="card-hearder">
              <span>Detalle del logs digital</span>
            </Card.Header>

            <Card.Body>
              {
                query.isLoading ?
                  <div className="text-center my-4">
                    <Spinner />
                  </div>
                  :
                  <DetailsCard log={query.data && query.data.result} />
              }
            </Card.Body>
          </Card>
        </div>
        <div className="col-12 mb-2 col-lg-6">
          {
            query.data && query.data.result && query.data.result.platform == 'AWS' ? (
              <Card className="shadow-sm mb-3">
                <Card.Header className="card-hearder">
                  <span>Detalle cuenta AWS</span>
                </Card.Header>

                <Card.Body>
                  {
                    query.isLoading ?
                      <div className="text-center my-4">
                        <Spinner />
                      </div>
                      :
                      <DetailsAWSCard log={query.data && query.data.result} />
                  }
                </Card.Body>
              </Card>
            ) : null
          }
          {
            query.data && query.data.result && query.data.result.platform == 'GCP' ? (
              <Card className="shadow-sm mb-3">
                <Card.Header className="card-hearder">
                  <span>Detalle cuenta GCP</span>
                </Card.Header>

                <Card.Body>
                  {
                    query.isLoading ?
                      <div className="text-center my-4">
                        <Spinner />
                      </div>
                      :
                      <DetailsGCPCard log={query.data && query.data.result} />
                  }
                </Card.Body>
              </Card>
            ) : null
          }

        </div>
      </Row>

      <Row className="mb-2 pb-4">
        <div className="col-12 mb-2 col-lg-6">
          {
            query.data && query.data.result && query.data.result.platform == 'AWS' ? (
              <Card className="shadow-sm mb-3">
                <Card.Header className="card-hearder">
                  <span>Evento: {query.data && query.data.result.event_name ? translate(query.data && query.data.result.event_name) : "--"}</span>
                </Card.Header>

                <Card.Body>
                  {
                    query.isLoading ?
                      <div className="text-center my-4">
                        <Spinner />
                      </div>
                      :
                      <div>
                        {EventNameAWS(query.data && query.data.result)}
                      </div>
                  }
                </Card.Body>
              </Card>
            ) : null
          }
          {
            query.data && query.data.result && query.data.result.platform == 'GCP' ? (
              <Card className="shadow-sm mb-3">
                <Card.Header className="card-hearder">
                  <span>Evento: {query.data && query.data.result.event_name ? translate(query.data && query.data.result.event_name) : "--"}</span>
                </Card.Header>

                <Card.Body>
                  {
                    query.isLoading ?
                      <div className="text-center my-4">
                        <Spinner />
                      </div>
                      :
                      <div>
                        {EventNameGCP(query.data && query.data.result)}
                      </div>
                  }
                </Card.Body>
              </Card>
            ) : null
          }
        </div>
      </Row>

    </Container>
  )
}
